module.exports = __webpack_public_path__ + "img/title_no.0011d12c.svg";